"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToUtf8 = exports.utf8ToString = exports.bnToBigInt = exports.bigIntToBn = exports.bnToNumber = exports.parseMintAccount = exports.parseTokenAccount = exports.RawMintLayout = exports.u64Field = exports.numberField = exports.SignedNumberField = exports.NumberField = exports.PubkeyField = exports.pubkeyField = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const BL = __importStar(require("@solana/buffer-layout"));
const BLU = __importStar(require("@solana/buffer-layout-utils"));
/**
 * TODO:
 * @export
 * @param {string} [property]
 * @returns {PubkeyField}
 */
function pubkeyField(property) {
    return new PubkeyField(property);
}
exports.pubkeyField = pubkeyField;
/**
 * TODO:
 * @export
 * @class PubkeyField
 * @extends {BL.Layout}
 */
class PubkeyField extends BL.Layout {
    /**
     * Creates an instance of PubkeyField.
     * @param {string} [property]
     * @memberof PubkeyField
     */
    constructor(property) {
        super(32, property);
    }
    /**
     * TODO:
     * @param {Uint8Array} b
     * @param {number} [offset]
     * @returns {PublicKey}
     * @memberof PubkeyField
     */
    decode(b, offset) {
        const start = offset !== null && offset !== void 0 ? offset : 0;
        const data = b.slice(start, start + this.span);
        return new web3_js_1.PublicKey(data);
    }
    /**
     * TODO:
     * @param {PublicKey} src
     * @param {Uint8Array} b
     * @param {number} [offset]
     * @returns {number}
     * @memberof PubkeyField
     */
    encode(src, b, offset) {
        const start = offset !== null && offset !== void 0 ? offset : 0;
        b.set(src.toBytes(), start);
        return this.span;
    }
}
exports.PubkeyField = PubkeyField;
/**
 * TODO:
 * @export
 * @class NumberField
 * @extends {BL.Layout}
 */
class NumberField extends BL.Layout {
    /**
     * Creates an instance of NumberField which decodes to a BN.
     * @param span The number of bytes in the number
     * @param property Field name within in a struct
     */
    constructor(span, property) {
        super(span, property);
    }
    /**
     * TODO:
     * @param {Uint8Array} b
     * @param {number} [offset]
     * @returns {BN}
     * @memberof NumberField
     */
    decode(b, offset) {
        const start = offset !== null && offset !== void 0 ? offset : 0;
        const data = b.slice(start, start + this.span);
        return new anchor_1.BN(data, undefined, "le");
    }
    /**
     * TODO:
     * @param {BN} src
     * @param {Uint8Array} b
     * @param {number} [offset]
     * @returns {number}
     * @memberof NumberField
     */
    encode(src, b, offset) {
        const start = offset !== null && offset !== void 0 ? offset : 0;
        b.set(src.toArray("le"), start);
        return this.span;
    }
}
exports.NumberField = NumberField;
/**
 * TODO:
 * @export
 * @class SignedNumberField
 * @extends {BL.Layout}
 */
class SignedNumberField extends BL.Layout {
    /**
     * Creates an instance of SignedNumberField.
     * @param {number} span
     * @param {string} [property]
     * @memberof SignedNumberField
     */
    constructor(span, property) {
        super(span, property);
    }
    /**
     * TODO:
     * @param {Uint8Array} b
     * @param {number} [offset]
     * @returns {BN}
     * @memberof SignedNumberField
     */
    decode(b, offset) {
        const start = offset == undefined ? 0 : offset;
        const data = b.slice(start, start + this.span);
        return new anchor_1.BN(data, undefined, "le").fromTwos(this.span * 8);
    }
    /**
     * TODO:
     * @param {BN} src
     * @param {Uint8Array} b
     * @param {number} [offset]
     * @returns {number}
     * @memberof SignedNumberField
     */
    encode(src, b, offset) {
        const start = offset == undefined ? 0 : offset;
        b.set(src.toTwos(this.span * 8).toArray("le"), start);
        return this.span;
    }
}
exports.SignedNumberField = SignedNumberField;
/**
 * Returns an unsigned number field that is 24 bytes wide
 * @export
 * @param {string} [property]
 * @returns {NumberField}
 */
function numberField(property) {
    return new NumberField(24, property);
}
exports.numberField = numberField;
/**
 * Returns an unsigned number field that is 8 bytes wide
 * @param property
 * @returns
 */
function u64Field(property) {
    return new NumberField(8, property);
}
exports.u64Field = u64Field;
const RawTokenAccountLayout = BL.struct([
    BLU.publicKey("mint"),
    pubkeyField("owner"),
    u64Field("amount"),
    BL.u32("delegateOption"),
    pubkeyField("delegate"),
    BL.u8("state"),
    BL.u32("isNativeOption"),
    u64Field("isNative"),
    u64Field("delegatedAmount"),
    BL.u32("closeAuthorityOption"),
    pubkeyField("closeAuthority")
]);
/** Buffer layout for de/serializing a mint */
exports.RawMintLayout = BL.struct([
    BL.u32("mintAuthorityOption"),
    BLU.publicKey("mintAuthority"),
    u64Field("supply"),
    BL.u8("decimals"),
    BLU.bool("isInitialized"),
    BL.u32("freezeAuthorityOption"),
    BLU.publicKey("freezeAuthority")
]);
/**
 * Decode a token account
 * @param {Buffer} account
 * @param {PublicKey} accountPubkey
 * @returns
 */
const parseTokenAccount = (account, accountAddress) => {
    const data = RawTokenAccountLayout.decode(account);
    // PublicKeys and BNs are currently Uint8 arrays and
    // booleans are really Uint8s. Convert them
    const decoded = {
        address: accountAddress,
        mint: data.mint,
        owner: data.owner,
        amount: data.amount,
        delegate: data.delegateOption === 1 ? data.delegate : undefined,
        delegatedAmount: data.delegatedAmount,
        isInitialized: data.state !== 0,
        isFrozen: data.state === 2,
        isNative: data.isNativeOption === 1,
        rentExemptReserve: data.isNativeOption === 1 ? data.isNative : new anchor_1.BN(0),
        closeAuthority: data.closeAuthorityOption === 1 ? data.closeAuthority : undefined
    };
    return decoded;
};
exports.parseTokenAccount = parseTokenAccount;
/**
 * Decode a mint account
 * @param {Buffer} mint
 * @param {PublicKey} mintAddress
 * @returns {Mint}
 */
const parseMintAccount = (mint, mintAddress) => {
    const data = exports.RawMintLayout.decode(mint);
    const decoded = {
        address: mintAddress,
        mintAuthority: data.mintAuthorityOption === 1 ? data.mintAuthority : undefined,
        supply: data.supply,
        decimals: data.decimals,
        isInitialized: data.isInitialized,
        freezeAuthority: data.freezeAuthorityOption === 1 ? data.freezeAuthority : undefined
    };
    return decoded;
};
exports.parseMintAccount = parseMintAccount;
/**
 * Convert BN to precise number
 * @param {BN} [bn]
 * @returns {number}
 */
const bnToNumber = (bn) => {
    return bn ? parseFloat(bn.toString()) : 0;
};
exports.bnToNumber = bnToNumber;
/**
 * Convert BigInt (spl) to BN (Anchor)
 * @param {bigint} [bigInt]
 * @returns {BN}
 */
const bigIntToBn = (bigInt) => {
    return bigInt ? new anchor_1.BN(bigInt.toString()) : new anchor_1.BN(0);
};
exports.bigIntToBn = bigIntToBn;
/**
 * Convert BN (Anchor) to BigInt (spl)
 * @param {bn} [bn]
 * @returns {bigint}
 */
const bnToBigInt = (bn) => {
    let result;
    if (typeof bn === "number") {
        result = BigInt(bn);
    }
    else {
        result = bn ? BigInt(bn.toNumber()) : BigInt(0);
    }
    return result;
};
exports.bnToBigInt = bnToBigInt;
const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder("utf-8");
const utf8ToString = (bytes, length) => {
    return textDecoder.decode(new Uint8Array(bytes.slice(0, length)));
};
exports.utf8ToString = utf8ToString;
const stringToUtf8 = (string) => {
    return Array.from(textEncoder.encode(string));
};
exports.stringToUtf8 = stringToUtf8;
//# sourceMappingURL=accountParser.js.map